import ClientTile from "./WithHubContext";

export default ClientTile;
